import React, { useCallback, useEffect, useState } from "react";
import { Link, Redirect } from "react-router-dom";
import client from "@culturehq/client";
import { Panel, Success } from "@culturehq/components";

import { useFetch } from "app/hooks";
import { Trans } from "app/utils";

import DefaultPanel from "components/display/DefaultPanel";
import ErrorPage from "components/ErrorPage";
import SurveyTake from "components/survey/SurveyTake";

import styles from "../not-found.module.scss";

const NotFound = () => (
  <div className={styles.container}>
    <h1>
      <Trans>Survey not found</Trans>
    </h1>
    <hr />
    <p>
      <Trans>
        The survey you were looking to take could not be found. This could
        be because you already completed the survey or were given an
        incorrect link. <Link to="/surveys">Click here</Link> to return to the
        list of available surveys.
      </Trans>
    </p>
  </div>
);

const TakeSurveyCallout = ({ match }) => {
  const [complete, setComplete] = useState(false);
  const [redirect, setRedirect] = useState(false);

  const { error, fetching, json: { survey } } = useFetch(
    () => client.getProfileAvailableWidgetSurvey({ surveyId: match.params.surveyId }),
    [match.params.surveyId]
  );

  const onSurveyComplete = useCallback(() => setComplete(true), [setComplete]);
  useEffect(
    () => {
      if (complete) {
        const timeout = setTimeout(() => setRedirect(true), 1500);
        return () => clearTimeout(timeout);
      }

      return undefined;
    },
    [complete, setRedirect]
  );

  if (redirect) {
    return <Redirect to="/surveys" />;
  }

  if (error && error.status === 404) {
    return <NotFound />;
  }

  if (error) {
    return <ErrorPage error={error} />;
  }

  if (fetching) {
    return <DefaultPanel className="max-width-900" />;
  }

  return (
    <Panel className="max-width-900">
      <Panel.Heading>
        {survey.title}
      </Panel.Heading>
      <Panel.Body>
        {
          complete
            ? <Success><Trans>Survey complete!</Trans></Success>
            : <SurveyTake survey={survey} onSurveyComplete={onSurveyComplete} />
        }
      </Panel.Body>
    </Panel>
  );
};

export default TakeSurveyCallout;
